export const preguntasData = {
    title: "¿Tienes dudas? ",
    description: "<p>Chequea nuestras preguntas frecuentes</p>",

    link: {
        label: "Ir al centro de ayuda",
        url: "https://www.google.com",
    },

    items: [
        {
            pregunta: "¿Qué es Toke?",
            respuesta: "<p>Toke es la nueva app de pagos digitales que te permite enviar y recibir dinero a cuentas Popular y Qik usando tu número celular o código QR.</p>"
        },

        {
            pregunta: "¿Necesito tener una cuenta bancaria para usar Toke?",
            respuesta: "<p>¡Toke es para todo el mundo! Solo necesitas tu cédula para obtener tu cuenta. ¡Es gratis y en segundos!</p>"
        },

        {
            pregunta: "¿Toke tiene algún costo?",
            respuesta: "<p>Con Toke puedes crear tu cuenta y manejar tu dinero gratis, no tienes comisiones y tus pagos se realizan al instante.</p><p>Al pagar, solo aplica el 0.15 % de impuesto establecido por la DGII para transferencias a otras personas.</p>"
        },

        {
            pregunta: "¿Qué requisitos debo cumplir para crear una cuenta a través de la App Toke?",
            respuesta: "<p>Para poder crearte una cuenta en App Toke de forma 100% digital debes ser dominicano mayor de edad (+18 años) con cédula dominicana y un número de celular activo.</p>"
        },

        {
            pregunta: "¿Qué es una Cuenta Flash?",
            respuesta: "<p>Es una cuenta que no tiene costos mensuales, está diseñada para nuevos clientes que buscan control de gastos e ingresos.</br> Ábrela hoy mismo en minutos y controla tus finanzas sin papeleos ni pagar comisiones. Esta cuenta tiene un límite transaccional de RD$75,000 mensuales.</p>"
        },
        {
            pregunta: "¿Cuáles son los beneficios de la Cuenta Flash?",
            respuesta: "<p>Con Cuenta Flash obtienes:</p><ul><li> Sin comisiones mensuales</li> <li>Movimientos 24/7</li> <li>Balance mínimo RD$0</li> <li>Sin cargos por bajo balance</li><li>Depósitos y retiros sin tarjeta con Código Cash en cajeros automáticos de Banco Popular</li></ul>"
        },

        {
            pregunta: "¿Desde qué Bancos o Apps puedo activar Toke?",
            respuesta: "<p>Actualmente puedes activar Toke desde el App Popular, App Qik y/o App Toke</p>"
        },
        {
            pregunta: "¿Cómo me aseguran que mis transacciones estarán protegidas?",
            respuesta: "<p>Utilizamos la misma infraestructura de seguridad tecnológica del Banco Popular Dominicano, es decir, cifrado de datos, monitoreo en tiempo real y sistemas antifraude.</p>"
        },
        {
            pregunta: "¿Cómo deposito dinero en mi cuenta Toke?",
            respuesta: "<p>Puedes ingresar dinero si otra persona te realiza un pago desde Popular o Qik usando tu código QR o número de celular.</p><p>También puedes realizar depósitos directamente desde las sucursales de Banco Popular o la red de subagentes bancarios a nivel nacional.</p><p>Desde otros bancos también puedes realizar transferencias usando tu número de cuenta Toke y cédula a través de la red ACH o pagos instantáneos LBTR.</p>"
        },
        {
            pregunta: "¿Cómo retiro dinero en efectivo?",
            respuesta: "<p>Con Toke no necesitarás efectivo, pero si alguien aún no se une, puedes retirar efectivo sin comisiones con Código Cash desde la red de cajeros automáticos de Banco Popular.</p>"
        }
    ]
};
